export const DEFAULT_DATETIME_TIME = "10:00";
